module.exports = __webpack_public_path__ + "static/media/buy_req_teach_4.08f9b2ab.jpg";